module.exports = {
    apiEndpointUrl: process.env.NODE_ENV == 'development'
    ? 'http://localhost:8003' : 'http://epa-beta.zennerslab.com:8003'
   }
   
